import { userActions } from "./user";

export const user_actions = {
  ...userActions
};
export { default as userSlice } from "./user";
